import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const PAYMENT: AppRouteRecordRaw = {
  path: '/payment',
  name: 'payment',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '支付配置',
    icon: 'icon-safe',
    requiresAuth: true,
    superAdminOnly: true,
    order: 10,
  },
  children: [
    {
      path: 'config',
      name: 'PaymentConfig',
      component: () => import('@/views/payment/config/index.vue'),
      meta: {
        locale: '支付通道切换',
        requiresAuth: true,
        roles: ['*'],
        superAdminOnly: true,
      },
    },
  ],
};

export default PAYMENT;
